import { render } from "./LocationFields.vue?vue&type=template&id=5bfb6474"
import script from "./LocationFields.vue?vue&type=script&lang=js"
export * from "./LocationFields.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/circleci/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__